<template>
  <div class="e404">
    <div class="svg">
      <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512.004 512.004"
        style="enable-background:new 0 0 512.004 512.004;"
        xml:space="preserve"
      >
        <g>
          <path
            style="fill:var(--bg-color);"
            d="M179.953,273.774l-23.287-23.287l61.491-61.491c6.434-6.434,16.862-6.434,23.287,0l0,0
		c6.434,6.434,6.434,16.862,0,23.287L179.953,273.774z"
          />
          <path
            style="fill:var(--bg-color);"
            d="M262.624,354.132l-23.287-23.287l60.339-60.339c6.434-6.434,16.862-6.434,23.287,0l0,0
		c6.434,6.434,6.434,16.862,0,23.287L262.624,354.132z"
          />
        </g>
        <rect
          x="436.922"
          y="4.189"
          transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 732.6243 420.4524)"
          style="fill:#6C797A;"
          width="32.938"
          height="108.611"
        />
        <path
          style="fill:#AFB6BB;"
          d="M418.135,152.046l-58.231-58.231l20.864-20.864c6.665-6.665,17.468-6.665,24.132,0l34.099,34.099
	c6.665,6.665,6.665,17.468,0,24.132L418.135,152.046z"
        />
        <path
          style="fill:#E7ECED;"
          d="M381.195,282.154l-151.398-151.39l50.936-50.935c23.322-23.322,61.133-23.322,84.454,0l66.935,66.935
	c23.322,23.322,23.322,61.133,0,84.454L381.195,282.154z"
        />
        <rect
          x="42.697"
          y="397.659"
          transform="matrix(0.7071 0.7071 -0.7071 0.7071 337.4932 90.779)"
          style="fill:#6C797A;"
          width="32.938"
          height="110.241"
        />
        <path
          style="fill:#AFB6BB;"
          d="M93.869,359.858L152.1,418.09l-20.864,20.864c-6.665,6.665-17.468,6.665-24.132,0l-34.099-34.099
	c-6.665-6.665-6.665-17.468,0-24.132L93.869,359.858z"
        />
        <path
          style="fill:#E7ECED;"
          d="M142.458,218.102l151.39,151.39l-62.583,62.583c-23.322,23.322-61.133,23.322-84.454,0L79.874,365.14
	c-23.322-23.322-23.322-61.133,0-84.454L142.458,218.102z"
        />
        <rect
          x="97.477"
          y="307.422"
          transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 52.2492 702.363)"
          style="fill:var(--shrink);"
          width="148.223"
          height="65.877"
        />
        <g>
          <path
            style="fill:var(--sub-color);"
            d="M433.598,110.181L433.598,110.181c-2.261,0-4.437-0.896-6.033-2.5l-23.287-23.287
		c-3.337-3.337-3.337-8.73,0-12.066l69.871-69.871c3.2-3.2,8.866-3.2,12.066,0l23.287,23.287c3.337,3.337,3.337,8.73,0,12.066
		l-69.871,69.871C438.027,109.285,435.859,110.181,433.598,110.181z M422.377,78.361l11.221,11.221l57.805-57.805l-11.221-11.221
		L422.377,78.361z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M427.77,150.945L427.77,150.945c-2.261,0-4.437-0.896-6.033-2.5l-58.231-58.231
		c-1.604-1.604-2.5-3.772-2.5-6.033c0-2.27,0.896-4.437,2.5-6.033l11.23-11.221c9.984-9.984,26.214-9.984,36.198,0l34.099,34.099
		c9.984,9.984,9.984,26.214,0,36.198l-11.221,11.221C432.207,150.041,430.039,150.945,427.77,150.945z M381.613,84.172
		l46.157,46.165l5.188-5.188c3.328-3.328,3.328-8.738,0-12.066l-34.091-34.099c-3.328-3.328-8.738-3.311-12.066,0L381.613,84.172z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M381.186,290.687c-2.185,0-4.369-0.836-6.033-2.5l-151.39-151.398c-1.604-1.604-2.5-3.763-2.5-6.033
		s0.896-4.437,2.5-6.033l50.935-50.935c12.894-12.894,30.029-19.994,48.256-19.994c18.236,0,35.371,7.1,48.265,19.994l66.935,66.935
		c26.607,26.607,26.607,69.914,0,96.529l-50.935,50.935C385.555,289.851,383.371,290.687,381.186,290.687z M241.862,130.755
		l139.324,139.332l44.902-44.902c19.951-19.959,19.951-52.437,0-72.388l-66.935-66.935c-9.668-9.668-22.519-14.993-36.198-14.993
		c-13.67,0-26.522,5.325-36.19,14.993L241.862,130.755z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M363.727,133.477c-2.185,0-4.369-0.836-6.033-2.5l-23.296-23.305
		c-6.298-6.298-16.546-6.298-22.852,0l-23.296,23.305c-3.328,3.337-8.73,3.337-12.066,0c-3.337-3.337-3.337-8.73,0-12.066
		l23.296-23.305c12.954-12.954,34.022-12.954,46.985,0l23.296,23.305c3.337,3.337,3.337,8.73,0,12.066
		C368.087,132.641,365.903,133.477,363.727,133.477z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M31.823,511.948c-2.261,0-4.437-0.896-6.033-2.5L2.502,486.16c-3.337-3.337-3.337-8.73,0-12.066
		l69.871-69.871c1.604-1.604,3.772-2.5,6.033-2.5l0,0c2.261,0,4.437,0.896,6.033,2.5l23.287,23.287c3.337,3.337,3.337,8.73,0,12.066
		l-69.871,69.871C36.26,511.052,34.093,511.948,31.823,511.948z M20.602,480.127l11.221,11.221l57.805-57.805l-11.221-11.221
		L20.602,480.127z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M119.162,452.47c-6.554,0-13.107-2.492-18.099-7.484l-34.099-34.099
		c-9.984-9.984-9.984-26.214,0-36.198l11.221-11.221c1.604-1.604,3.772-2.5,6.033-2.5l0,0c2.261,0,4.437,0.896,6.033,2.5
		l58.231,58.231c1.604,1.604,2.5,3.772,2.5,6.033c0,2.27-0.896,4.437-2.5,6.033l-11.23,11.221
		C132.269,449.979,125.715,452.47,119.162,452.47z M84.235,381.558l-5.188,5.188c-3.328,3.328-3.328,8.738,0,12.066l34.099,34.099
		c3.328,3.328,8.738,3.311,12.066,0l5.188-5.188L84.235,381.558z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M189.041,458.102c-18.236,0-35.371-7.1-48.265-19.994l-66.935-66.935
		c-26.607-26.607-26.607-69.914,0-96.529l62.583-62.583c3.2-3.2,8.866-3.2,12.066,0l151.39,151.39c3.337,3.337,3.337,8.73,0,12.066
		L237.306,438.1C224.412,451.003,207.277,458.102,189.041,458.102z M142.458,230.169l-56.55,56.55
		c-19.951,19.959-19.951,52.437,0,72.388l66.935,66.935c9.668,9.668,22.519,14.993,36.198,14.993c13.67,0,26.522-5.325,36.19-14.993
		l56.542-56.55L142.458,230.169z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M189.041,273.219c-2.185,0-4.369-0.836-6.033-2.5l-23.287-23.287c-1.604-1.604-2.5-3.763-2.5-6.033
		c0-2.27,0.896-4.437,2.5-6.033l52.412-52.403c9.438-9.455,25.907-9.446,35.362,0c4.719,4.719,7.322,10.991,7.322,17.673
		s-2.603,12.962-7.322,17.681l-52.403,52.403C193.41,272.383,191.226,273.219,189.041,273.219z M177.811,241.39l11.221,11.221
		l46.37-46.37c1.502-1.502,2.321-3.49,2.321-5.615c0-2.116-0.828-4.105-2.321-5.598c-3.004-3.012-8.226-3.012-11.221-0.009
		L177.811,241.39z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M270.56,354.73c-2.185,0-4.369-0.836-6.033-2.5l-23.287-23.287c-1.604-1.604-2.5-3.763-2.5-6.033
		s0.896-4.437,2.5-6.033l52.403-52.403c9.754-9.762,25.609-9.754,35.362,0c9.745,9.754,9.745,25.609,0,35.362l-52.412,52.403
		C274.929,353.902,272.745,354.73,270.56,354.73z M259.339,322.909l11.221,11.221l46.37-46.37c3.089-3.089,3.089-8.132,0-11.221
		c-2.995-3.004-8.218-3.004-11.221,0L259.339,322.909z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M200.689,424.609c-2.185,0-4.369-0.836-6.033-2.5L89.841,317.302c-3.337-3.337-3.337-8.73,0-12.066
		l46.583-46.583c3.337-3.337,8.73-3.337,12.066,0l104.806,104.806c3.337,3.337,3.337,8.73,0,12.066l-46.583,46.583
		C205.05,423.773,202.865,424.609,200.689,424.609z M107.94,311.269l92.74,92.74l34.517-34.517l-92.74-92.74L107.94,311.269z"
          />
          <path
            style="fill:var(--sub-color);"
            d="M189.041,366.386c-2.185,0-4.369-0.836-6.033-2.5l-34.935-34.944c-3.337-3.337-3.337-8.73,0-12.066
		c3.337-3.337,8.73-3.337,12.066,0l34.935,34.944c3.337,3.337,3.337,8.73,0,12.066C193.41,365.55,191.226,366.386,189.041,366.386z"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    </div>
    <p>خطا در برقراری ارتباط</p>
    <a @click.prevent="reload" href="">بازنشانی صفحه</a>
  </div>
</template>
<script>
export default {
  methods: {
    reload() {
      location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.e404 {
  width: 100%;
  height: 100vh;
  background: var(--bg-color);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7897897897897897897;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h1 {
    font-size: 3em;
    // font-family: "lalezar";
    color: var(--sub-color);
    width: 200px;
    height: 200px;
    border-radius: 50%;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.185);
    background: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  p {
    margin-top: 1em;
    font-size: 1.5em;
    color: var(--sub-color);
    background: var(--main-color);
    padding: 0.25em 2em;
    border-radius: 5px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.178);
  }
  a {
    text-decoration: none;
    color: var(--main-color);
    background: var(--sub-color);
    padding: 0.25em 2em;
    border-radius: 5px;
    margin-top: 1em;
  }
  .svg {
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/errors/404.vue